export { LoginComponent } from "./login.component";
export { LoginModule } from "./login.module";

